import { jsxs as v, jsx as l } from "react/jsx-runtime";
const o = (r) => /* @__PURE__ */ v(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M35.722 53.837H17.892v-39.55h28.159v19.497a13.086 13.086 0 0 1 4.163.42v-24.08h-7.806V6.057H21.592v4.067h-3.7c-2.265 0-4.1 1.864-4.1 4.163v39.55c0 2.3 1.835 4.163 4.1 4.163H39.896a13.215 13.215 0 0 1-4.174-4.163Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M21.592 49.77h12.447a13.109 13.109 0 0 1 .89-8.403H21.593v8.404ZM21.592 38.309h15.316a13.163 13.163 0 0 1 5.5-3.78v-4.624H21.592v8.404ZM21.592 26.846h20.816v-8.403H21.592v8.403Zm2.082-6.322h16.652v4.24H23.674v-4.24ZM51.823 41.996l-5.885 5.884-3.031-3.032-2.122 2.122 5.154 5.153 6.78-6.781-.896-3.346Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M46.874 35.748c-6.145 0-11.126 4.981-11.126 11.126S40.729 58 46.874 58 58 53.02 58 46.874s-4.981-11.126-11.126-11.126Zm0 19.252c-4.48 0-8.126-3.645-8.126-8.126 0-4.48 3.645-8.126 8.126-8.126 4.48 0 8.126 3.645 8.126 8.126C55 51.354 51.355 55 46.874 55Z"
        }
      )
    ]
  }
);
export {
  o as RealCharge2
};
